wbApp.controller('SignInCtrl', ['$scope', 'securitySvc', '$window', '$translate', '$modal', '$timeout', 'urlUtils',
    function ($scope, securitySvc, $window, $translate, $modal, $timeout, urlUtils) {
    $scope.model = {
        email: null,
        password: null
    };

    let signInReturnPath = urlUtils.getQueryParams()['signIn'];
    
    $scope.emailVerificationMode = false;
    
    $scope.onPasswordReset = function() {
        $scope.$hide();
        passwordResetDialogPromise.$promise.then(function () {
            passwordResetDialogPromise.$scope.model = {
                email: $scope.model.email,
                password: null,
                otp: null
            };
            passwordResetDialogPromise.show();
        });        
    }
    
    function signInFlow(model) {
        $scope.isSaving = true;
        securitySvc.signIn(model.email, model.password).then(
            function (success) {
                $scope.isSaving = false;
                $scope.$hide();
                if (!!signInReturnPath) {
                    $timeout(function () {
                        $window.location = signInReturnPath;
                    }, 500);                    
                } else {
                    $timeout(function () {
                        $window.location.reload();
                    }, 500);
                }
            },
            function (error) {
                if (!error) {
                    $scope.detailError = $translate.instant('TXT_SIGN_IN_FAILED');
                    $scope.isSaving = false;
                    return;
                }
                switch(error.code) {
                    case 'wb/user-email-not-verified':
                        $scope.emailVerificationMode = true;
                        securitySvc.sendEmailVerificationAuthorizationCode(model.email).then(
                            function(evSuccess) {
                                $scope.isSaving = false;
                            },
                            function(evError) {
                                if (!!evError && !!evError.title) {
                                    if (evError.title.includes("EMAIL_NOT_FOUND")) {
                                        $scope.detailError = $translate.instant('TXT_LOGIN_ERROR_USER_NOT_FOUND');
                                    } else if (evError.title.includes('INVALID_EMAIL')) {
                                        $scope.detailError = $translate.instant('TXT_LOGIN_ERROR_INVALID_EMAIL');
                                    } else {
                                        $scope.detailError = evError.title;
                                    }
                                } else {
                                    $scope.detailError = $translate.instant('TXT_OTP_GENERATE_BUSY');
                                }
                                $scope.isSaving = false;
                            }
                        )
                        break;
                    default:
                        $scope.detailError = securitySvc.gcpErrorCodeToText(error);
                }
                $scope.isSaving = false;
            });
    }
    
    function emailVerificationFlow(model) {
        $scope.isSaving = true;
        securitySvc.confirmEmailVerification(model.email, model.otp).then(
            function() {
                signInFlow(model);
            },
            function(error) {
                $scope.isSaving = false;
                if (!error) {
                    $scope.detailError = $translate.instant('TXT_OTP_VERIFY_BUSY');
                } else {
                    if (!!error.title && error.title.includes("One time password does not exist or is expired.")) {
                        $scope.detailError = $translate.instant('TXT_OTP_DOES_NOT_EXIST');
                    } else if (!!error.title) {
                        $scope.detailError = error.title;
                    } else if (!!error.code) {
                        $scope.detailError = securitySvc.gcpErrorCodeToText(error); 
                    }
                }
            }
        );
    }
    
    $scope.onSignIn = function(model) {
        if ($scope.isSaving) {
            return;
        }
        
        if ($scope.emailVerificationMode) {
          return emailVerificationFlow(model);  
        } else {
          return signInFlow(model);  
        }
    }

    var passwordResetDialogPromise = $modal({
        templateUrl: 'sign-in/password-reset-dialog.html',
        show: false,
        scope: $scope.$new(true)
    });
}]);